import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useBatchId } from '../../../hooks/useBatchId';
import { useToastMessage } from '../../../hooks/useToastMessage';
import {
	CentralTeamDashboardFilter,
	PreceptorApplicationCentralTeamDashboardResponse,
} from '../../../shared/ScreeningServiceTypes';
import { getCentralTeamDashboardDetail } from '../../../service/ScreeningService';
import {
	ApplicationStatusType,
	Batch,
} from '../../../shared/VolunteerApplicationServiceTypes';
import useUserSession from '../../../hooks/useUserSession';

export const useCentralTeamDashboard = () => {
	const { srcmId } = useAuth();
	const { selectedRole } = useUserSession();
	const { batchId } = useBatchId();
	const { showToastMessage } = useToastMessage();
	const [CTDDetail, setCTDDetail] =
		useState<PreceptorApplicationCentralTeamDashboardResponse>();

	const [CTDFilter, setCTDFilter] = useState<CentralTeamDashboardFilter>({});

	const onCTDFilterChange = useCallback(
		(filterParam: CentralTeamDashboardFilter) => {
			setCTDFilter(filterParam);
		},
		[]
	);

	const getCTDDetail = useCallback(
		async (filter: CentralTeamDashboardFilter, batchListId: number) => {
			if (srcmId && batchListId && selectedRole) {
				try {
					const request = {
						...filter,
						batchId: [batchListId],
						functionarySrcmId: srcmId,
						selectedRoleCode: selectedRole,
						applicationStatus: [
							'APPROVED',
							'REJECTED',
						] as ApplicationStatusType[],
					};
					const CTDResponse = await getCentralTeamDashboardDetail(request);

					if (CTDResponse) {
						setCTDDetail(CTDResponse);
					}
				} catch (err) {
					showToastMessage(
						'error',
						err instanceof Error ? err.message : 'Unknown error occurred'
					);
				}
			}
		},
		[srcmId, selectedRole, showToastMessage]
	);

	useEffect(() => {
		const selectedBatchDetails = sessionStorage.getItem('SELECTED_BATCH');

		if (selectedBatchDetails) {
			const parsedData: Batch = JSON.parse(selectedBatchDetails) as Batch;
			void getCTDDetail(CTDFilter, parsedData.id as number);
		} else {
			void getCTDDetail(CTDFilter, batchId);
		}
	}, [CTDFilter, getCTDDetail, batchId]);

	return {
		CTDDetail,
		CTDFilter,
		onCTDFilterChange,
	};
};
